module.exports = __webpack_public_path__ + "img/file.f6bcd0c6.png";